import { useHideElements } from "hooks/useHideElements";
import { NavLink } from "hooks/useCustomNavigation";
import { useWindowDimensions } from "hooks/useWindowDimensions";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";
import { EXTERNAL_LINKS, INTERNAL_PATHS } from "routes/paths";
import {
  CheckoutCopyright,
  CheckoutMobileSteps,
  Loader
} from "components/UI/atoms";
import {
  Breadcrumb,
  OrderFaq,
  OrderInfo,
  OrderOffer,
  MobileOrderPageLogo
} from "components/UI/molecules";
import {
  CheckoutHeader,
  OrderFeedback,
  OrderSummary
} from "components/UI/organisms";
import { ReactComponent as EnvelopeIcon } from "assets/icons/order/envelope.svg";
import { useGetOrder } from "./utils/useGetOrder";
import "./index.scss";

export const Order = () => {
  const { order, loading } = useGetOrder();
  const { width } = useWindowDimensions();
  const isTablet = width >= 768;

  const HIDDEN_ELEMENTS = [".navbar-header", "footer#portal-footer-container"];
  useHideElements(HIDDEN_ELEMENTS);

  const isReady = !loading && !!order;

  return (
    <div className="order">
      <ReactHelmetWithProvider>
        <title>GCX - Order Receipt</title>
        <meta name="robots" content="noindex" />
      </ReactHelmetWithProvider>
      <MobileOrderPageLogo />
      <CheckoutMobileSteps />

      {!isReady ? (
        <Loader variant="secondary" id="page-loader" />
      ) : (
        <>
          {isTablet && (
            <>
              <CheckoutHeader step={3} />
              <Breadcrumb
                rightSide={
                  <div className="breadcrumb-email-container">
                    <EnvelopeIcon />
                    <NavLink to={EXTERNAL_LINKS.MARKETPLACE_ZENDESK}>
                      Email Us
                    </NavLink>
                  </div>
                }
                list={[
                  {
                    label: "< Continue Shopping",
                    linkTo: INTERNAL_PATHS.BUY_GIFT_CARDS
                  }
                ]}
                customClassname="order-breadcrumb"
              />
            </>
          )}
          <div className="content-wrapper">
            <main className="content">
              <div className="left-column">
                <h1 className="page-title">Thank you for your order!</h1>
                <OrderFeedback
                  gifting_email={order.gifting_email}
                  payment={order.payment}
                  line_items={order.line_items}
                  totals={order.totals}
                />
                {order.bundle_offer && <OrderOffer {...order.bundle_offer} />}
                <OrderInfo
                  bill_address={order.bill_address}
                  date_formatted={order.date_formatted}
                  number={order.number}
                  payment={order.payment}
                />
                <OrderSummary cards={order.line_items} totals={order.totals} />
              </div>
              <div className="right-column">
                {order.bundle_offer && <OrderOffer {...order.bundle_offer} />}
                <OrderFaq />
              </div>
            </main>
            <footer className="order-receipt">
              <CheckoutCopyright customClassName="order-receipt-copyright" />
            </footer>
          </div>
        </>
      )}
    </div>
  );
};
